export interface IEMI_FORMULA {
  loanAmount: number | null;
  rateOfInterest: number | null;
  noOfMonths: number | null;
}

export const EMI_FORMULA = ({
  loanAmount,
  rateOfInterest,
  noOfMonths,
}: IEMI_FORMULA) => {
  if (loanAmount === null || noOfMonths === null || rateOfInterest === null)
    return {};

  if (noOfMonths === 0 || loanAmount === 0 || rateOfInterest === 0) {
    return {
      emiPayable: '0',
      totalLoanAmount: Number(loanAmount).toFixed(0),
      totalInterest: '0',
      payableAmount: '0',
    };
  }
  const P = loanAmount;
  const R = rateOfInterest / (12 * 100);

  const emi =
    (P * R * Math.pow(1 + R, noOfMonths)) / (Math.pow(1 + R, noOfMonths) - 1);
  const totalInterest = noOfMonths * emi - loanAmount;
  const payableAmount = noOfMonths * emi;

  return {
    emiPayable: Number(emi).toFixed(0),
    totalLoanAmount: Number(loanAmount).toFixed(0),
    totalInterest: Number(totalInterest).toFixed(0),
    payableAmount: Number(payableAmount).toFixed(0),
  };
};
